import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Contact() {
    return (

        <div className="inner-page contact-page">

            <Header />


            <div className="rts-breadcrumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="baread-crumb-main-wrapper pt--100">
                                <div className="inner">
                                    <h1 className="title rts_hero__title">Contact Now</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="our-approch-area-style-one rts-section-gap bg-dark-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="grid-lines-wrapper">
                                <div className="grid-lines">
                                    <div className="grid-line"></div>
                                    <div className="grid-line"></div>
                                    <div className="grid-line"></div>
                                    <div className="grid-line"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-7 col-md-6 rts-slide-right-gsap">

                            <div className="approch-area-left">
                                <div className="title-area-left-wrapper">
                                    <span className="pre-title">Let's Talk</span>
                                    <h2 style={{color: '#000' }}>Speak With <br /> Expert Engineers.</h2>
                                </div>
                                <div className="contact-box">
                                    <div className="address-box pt--25">
                                        <div className="address-icon">
                                            <i className="fa fa-home"></i>
                                        </div>
                                        <div className="address-text">
                                            <span className="label">Email:</span>
                                            <a href="mailto:support@warmonks.com">support@warmonks.com</a>
                                        </div>
                                    </div>
                                    <div className="address-box pt--25">
                                        <div className="address-icon">
                                            <i className="fa fa-phone"></i>
                                        </div>
                                        <div className="address-text">
                                            <span className="label">Phone:</span>
                                            <a href="tel:+919778544561">+91 97 78 54 45 61</a>
                                        </div>
                                    </div>
                                    <div className="address-box pt--25">
                                        <div className="address-icon">
                                            <i className="fa fa-map-marker"></i>
                                        </div>
                                        <div className="address-text">
                                            <span className="label">Address:</span>
                                            <div className="desc" style={{ paddingLeft: "20px" }}>3rd Floor, SSS Plaza, Mahatma Nagar, Kizhakkumpattukara,<br /> Thrissur, Kerala 680005</div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="col-lg-5 col-md-6 rts-slide-left-gsap mt_sm--30">
                            <img src="./assets/images/contact.gif" alt="" />
                        </div>
                    </div>
                </div>
            </div>


            <div className="appoinmnet-area-two rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="appoinment-area-two plr--120 plr_md--40 plr_sm--30">
                                <div className="title-area-appoinment">
                                    <span className="pre">Appointment</span>
                                    <h2 className="title mb--0">
                                        Love to hear from you <br />
                                        <span>Get in touch!</span>
                                    </h2>
                                </div>
                                <form className="appoinment-h2 rts-slide-up-gsap" action="#">
                                    <div className="input-line">
                                        <div className="input-half">
                                            <label for="name">Your Name*</label>
                                            <input id="name" type="text" placeholder="Enter Your Name...." required />
                                        </div>
                                        <div className="input-half">
                                            <label for="email">Your Email*</label>
                                            <input id="email" type="text" placeholder="enter your email" required />
                                        </div>
                                    </div>
                                    <div className="input-line mt--40">
                                        <div className="input-half">
                                            <label for="name">What you are interested*</label>
                                            <select className="form-select" aria-label="Default select example">
                                                <option selected>Choose your requirement</option>
                                                <option value="1">Website Development</option>
                                                <option value="2">App Development</option>
                                                <option value="3">Ecommerce Development</option>
                                                <option value="4">Digital Marketing</option>
                                                <option value="3">SEO</option>
                                                <option value="4">Graphic Designing</option>
                                            </select>
                                        </div>
                                        <div className="input-half">
                                            <label for="email">Project Budget*</label>
                                            <select className="form-select" aria-label="Default select example">
                                                <option selected>Design & Branding</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="text-area mt--40">
                                        <label for="message">Message*</label>
                                        <textarea id="message" cols="30" rows="10"
                                            placeholder="Let tell us about your projects"></textarea>
                                    </div>
                                    <button className="submit-pd">Post Comment</button>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="contact-map pt-120 md-pt-80">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3922.75106411421!2d76.22980867487884!3d10.520262663866822!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7efd9961be113%3A0xe92b48e35b03c47d!2sWarmonks!5e0!3m2!1sen!2sin!4v1731147224147!5m2!1sen!2sin"
                    width="800" height="600" style={{ border: "0" }} allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>

            <Footer />

            <div className="loading-screen" id="loading-screen">
                <span className="bar top-bar"></span>
                <span className="bar down-bar"></span>
                <span className="progress-line"></span>
                <span className="loading-counter"> </span>
            </div>


            <div className="bg-noise"></div>



            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
                </svg>
            </div>

            <div className="rts-cursor cursor-outer" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor"></span>
            </div>
            <div className="rts-cursor cursor-inner" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor">
                    <span className="fn-left"></span>
                    <span className="fn-right"></span>
                </span>
            </div>

            <div className="modal-sidebar-scroll rts-dark-light">
                <ul>
                    <li className="go-dark-w"><span>Dark</span><i className="rts-go-dark fal fa-moon"></i></li>
                    <li className="go-light-w"><span>Light</span><i className="rts-go-light fa-light fa-brightness"></i></li>
                </ul>
            </div>

        </div >
    )
}

export default Contact
